import React from 'react';
import {Route} from 'react-router-dom';
import AsyncPage from './async';

export default [
  <Route
    key="/business/services/virtual-makeup-instagram"
    exact
    path="/business/services/virtual-makeup-instagram"
    component={AsyncPage}
  />,
];
